import { useHistory } from 'react-router-dom';
import { Trans } from 'react-i18next';
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Select,
  MenuItem
} from '@mui/material';
import './CartDropdownItem.scss';
import LineAwesome from '../LineAwesome/LineAwesome';
import { StrapiProduct } from '../../core/models/strapi-product.model';
import { getPreviewImage } from '../../utils/imageUtils';

interface CartDropdownItemProps {
  product: StrapiProduct;
  quantity: number;
  disabled: boolean;
  onChangeQuantity: (quantity: number) => void;
  onDelete: () => void;
  toggleCart?: () => void;
}

const CartDropdownItem = ({
  product,
  quantity,
  disabled,
  onChangeQuantity,
  toggleCart,
  onDelete
}: CartDropdownItemProps) => {
  const history = useHistory();
  const productUnavailable =
    product.availableQuantity === 0 || product.inactive || product.requestOnly;

  const goToProduct = () => {
    history.push(`/produkt/${product.urlSegment}`);
    if (toggleCart) {
      toggleCart();
    }
  };

  return (
    <Box className='cart-dropdown-item ' key={product.id}>
      {productUnavailable && (
        <Box className='unavailable-header'>
          <Typography variant='caption' color='error.main'>
            <Trans i18nKey='product.unavailable'>Produkt aktuell nicht verfügbar</Trans>
          </Typography>
        </Box>
      )}
      <ListItem
        onClick={() => {
          if (productUnavailable) {
            return;
          }
          goToProduct();
        }}
        alignItems='center'
        className={`${productUnavailable ? 'unavailable' : 'available'}`}
        secondaryAction={
          <LineAwesome
            icon='trash'
            className='delete-icon'
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          />
        }>
        <ListItemAvatar>
          <Avatar
            className='image'
            variant='rounded'
            alt={product.title}
            src={getPreviewImage(product)}
          />
        </ListItemAvatar>
        <ListItemText
          primary={product.title}
          secondary={
            <Typography component='span' variant='body2' color='text.primary'>
              €{product.price.toFixed(2)}
            </Typography>
          }
        />
        <Box onClick={(e) => e.stopPropagation()}>
          <Select
            size='small'
            value={quantity}
            disabled={productUnavailable || disabled}
            onChange={(e) => onChangeQuantity(parseInt(e.target.value as string))}
            MenuProps={{ style: { zIndex: 15001 } }}>
            {Array.from(Array(product.availableQuantity), (_, i) => i + 1).map((val) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </ListItem>
    </Box>
  );
};

export default CartDropdownItem;
